import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Modal } from "@mui/material";
import styles from "../../assets/css/modules/searchModal.module.css";

export default function SearchModal(props) {
  const { t } = useTranslation("multiSearch");
  const { language } = useTranslation().i18n;
  const [validation, setValidation] = useState({});

  useEffect(() => {
    if (props.value === "PickupNo") {
      setValidation({
        pickupNo: yup.string().required("برجاء ادخال رقم الطلب "),
      });
    } else if (props.value === "AWBs") {
      setValidation({
        awbs: yup.string().required("برجاء ادخال رقم الشحنة"),
      });
    } else {
      setValidation({
        refs: yup.string().required("برجاء ادخال الرقم المرجعي "),
      });
    }
  }, [props]);

  const schema = yup.object(validation).required();
  const methods = useForm({
    mode: "onTouched",
    defaultValues: {
      refs: "",
      awbs: "",
      pickupNo: "",
    },
    resolver: yupResolver(schema),
  });

  const {
    handleSubmit,
    setValue,
    register,
    formState: { errors },
  } = methods;

  const submitForm = (data) => {
    setValue("refs", "");
    setValue("awbs", "");
    setValue("pickupNo", "");

    let body = {};
    if (props.value === "PickupNo") {
      body = {
        FromDate: "2020-04-20T13:23:30.141Z",
        ToDate: new Date().toISOString(),
        pickupNo: parseInt(data.pickupNo),
      };
    } else if (props.value === "AWBs") {
      body = {
        FromDate: "2020-04-20T13:23:30.141Z",
        ToDate: new Date().toISOString(),
        awBs: data.awbs,
      };
    } else {
      body = {
        FromDate: "2020-04-20T13:23:30.141Z",
        ToDate: new Date().toISOString(),
        reFs: data.refs,
      };
    }
    props.getShipments(body);
    props.setOpen(false);
  };

  const getSubtitle = () => {
    if (props.value === "PickupNo") {
      return language === "ar" 
        ? "أدخل رقم طلب البيك أب للبحث وجلب التفاصيل" 
        : "Enter the pickup ID to search and fetch details";
    }
    return language === "ar"
      ? "أدخل أكواد متعددة مفصولة بأسطر (سطر جديد لكل كود) أو فواصل"
      : "Enter multiple codes separated by new lines or commas";
  };

  return (
    <Modal
      open={props.open}
      onClose={() => {
        props.setValue("");
        props.setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className={styles.modalCard} dir={language === "ar" ? "rtl" : "ltr"}>
        {/* Close Button */}
        <button
          className={styles.closeBtn}
          onClick={() => {
            props.setOpen(false);
            props.setValue("");
          }}
          type="button"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        {/* Modal Header */}
        <div className={styles.modalHeader}>
          <div className={styles.modalTitle}>{t("multi_search")}</div>
          <div className={styles.modalSubtitle}>{getSubtitle()}</div>
        </div>

        {/* Modal Form */}
        <FormProvider {...methods}>
          <form className={styles.formContainer} onSubmit={handleSubmit(submitForm)}>
            {props.value === "PickupNo" && (
              <div className={styles.inputWrapper}>
                <label className={styles.inputLabel}>{t("pickup_no")}</label>
                <input
                  type="text"
                  placeholder={t("pickup_no")}
                  className={`${styles.inputField} ${errors.pickupNo ? styles.inputError : ""}`}
                  {...register("pickupNo")}
                />
                {errors.pickupNo && <span className={styles.errorMessage}>{errors.pickupNo.message}</span>}
              </div>
            )}

            {props.value === "AWBs" && (
              <div className={styles.inputWrapper}>
                <label className={styles.inputLabel}>{t("awb")}</label>
                <textarea
                  placeholder={language === "ar" ? "أدخل رقم شحنة في كل سطر..." : "Enter shipment numbers (one per line)..."}
                  className={`${styles.textareaField} ${errors.awbs ? styles.textareaError : ""}`}
                  {...register("awbs")}
                />
                {errors.awbs && <span className={styles.errorMessage}>{errors.awbs.message}</span>}
              </div>
            )}

            {props.value === "REFs" && (
              <div className={styles.inputWrapper}>
                <label className={styles.inputLabel}>{t("ref")}</label>
                <textarea
                  placeholder={language === "ar" ? "أدخل رقماً مرجعياً في كل سطر..." : "Enter reference numbers (one per line)..."}
                  className={`${styles.textareaField} ${errors.refs ? styles.textareaError : ""}`}
                  {...register("refs")}
                />
                {errors.refs && <span className={styles.errorMessage}>{errors.refs.message}</span>}
              </div>
            )}

            <button type="submit" className={styles.btnPrimary}>
              <span>{t("search")}</span>
            </button>
          </form>
        </FormProvider>
      </div>
    </Modal>
  );
}
